import CurrencyISO from '../mockdata/currencyISO.json';

export const formatFunction = (value) => {
    let selectedCurreny = localStorage.currency ? localStorage.getItem('currency') : 'Euro',

    formatter = new Intl.NumberFormat(CurrencyISO[selectedCurreny].language + '-' + CurrencyISO[selectedCurreny].Country, {
        style: 'currency',
        currency: CurrencyISO[selectedCurreny].Currency,
    });
    let nn = value;
    nn = (nn / 100);
    nn = nn.toFixed(2);
    nn = formatter.format(nn);
    return nn;
};